export * from "./Footer";
export { default } from "./Footer";